<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>발송 대량 저장</h1>
      </div>
    </div>

    <!-- grid 구역 -->
    <send-bundle-save-regi
        v-if="$route.params.sendScn === '01'"
        ref="sendBundleSaveRef"
        :sendInfo="sendInfo"
    ></send-bundle-save-regi>
    <send-bundle-save-deli
        v-if="$route.params.sendScn === '02'"
        ref="sendBundleSaveRef"
        :sendInfo="sendInfo"
    ></send-bundle-save-deli>
    <send-bundle-save-expr
        v-if="$route.params.sendScn === '03'"
        ref="sendBundleSaveRef"
        :sendInfo="sendInfo"
    ></send-bundle-save-expr>

    <div class="button_area w30">
      <ul>
        <li class="w25">
          <button class="large_btn" @click="$router.push({name: 'ManageSendList'})">목록</button>
        </li>
        <li class="w25">
          <button class="large_btn green" @click="onClickSave">저장</button>
        </li>
      </ul>
    </div>
<!--    <excel-upload-result-window-->
<!--        ref="excelUploadResultWindowRef"-->
<!--        :resultData="excelUploadResult"-->
<!--        :uploadData="pouchUploadData"-->
<!--        @onChange="$emit('onChange')"-->
<!--    >-->
<!--    </excel-upload-result-window>-->
  </section>
</template>

<script>
import $ from 'jquery'
import EtnersCommonUtil from "@/common/etners.common.util";
import ApiConfig from "@/api/api.config";

import SendBundleSaveRegi from "@/components/send/SendBundleSaveRegi";
import SendBundleSaveExpr from "@/components/send/SendBundleSaveExpr";
import SendBundleSaveDeli from "@/components/send/SendBundleSaveDeli";
import ExcelUploadResultWindow from "@/components/pouch/ExcelUploadResultWindow";

export default {
  name: "SendBundleSave",
  components: {SendBundleSaveRegi, SendBundleSaveExpr, SendBundleSaveDeli, ExcelUploadResultWindow},
  mounted() {
    const vm = this
    // 붙여넣기 이벤트 할당
    document.getElementById('contents_wrap').addEventListener('paste', vm.getClipBoard)
  },
  methods: {
    getClipBoard (e) {
      const vm = this
      let clipboardData, pastedData = null
      e.stopPropagation()
      e.preventDefault()

      // 윈도우 클립보드 내용 가져오기
      clipboardData = e.clipboardData || window.clipboardData
      pastedData = clipboardData.getData('Text')

      vm.setSendData(pastedData)
    },
    setSendData (pastedData) {
      const vm = this
      if (EtnersCommonUtil.isEmpty(pastedData)) {
        return false
      }
      let rows = pastedData.split('\n')
      if (rows.length > 1000) {
        kendo.alert('1000건 이상은 업데이트 할 수 없습니다.')
        return false
      }

      vm.$refs.sendBundleSaveRef.setSendData(rows)
    },
    callSaveApi () {

    },
    onClickSave () {
      const vm = this
      const dataSource = vm.$refs.sendBundleSaveRef.$refs.sendBatchGrid.kendoWidget().dataSource.data()
      if (dataSource.length < 1) {
        kendo.alert('데이터를 입력해주세요.')
        return false
      }
      kendo.confirm(`${dataSource.length}건의 데이터를 저장하시겠습니까?`).then(() => {
        vm.callSaveApi()
      })
    },
  },
  data () {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }

    let sendScnNm, sendScn, shpcScnNm, shpcScn
    switch (this.$route.params.sendScn) {
      case '01':
        sendScnNm = '등기'
        sendScn = '01'
        shpcScnNm = '우체국'
        shpcScn = '05'
        break
      case '02':
        sendScnNm = '택배'
        sendScn = '02'
        shpcScnNm = '일양택배'
        shpcScn = '04'
        break
      case '03':
        sendScnNm = '해외 특송'
        sendScn = '03'
        shpcScnNm = 'DHL'
        shpcScn = '01'
        break
    }
    return {
      loginUserToken : sessionStorage.getItem('loginUserToken'),
      excelUploadResult: null,
      pouchUploadData: null,

      sendBatchSaveSchema: {
        model: {
          id: "No",
          fields: {
            No: {editable: false},
            contentsScn: {editable: false},
            contentsDesc: {editable: true},
            sendFacility: {editable: false},
            sendBuilding: {editable: false},
            sendFloor: {editable: false},
            sendZone: {editable: false},
            sendNm: {editable: true},
            sendDept: {editable: true},
            sendMailAddr: {editable: true},
            sendAmpmScn: {editable: false},
            sendContents: {editable: true},
            receiveFacility: {editable: false},
            receiveBuilding: {editable: false},
            receiveFloor: {editable: false},
            receiveZone: {editable: false},
            receiveNm: {editable: true},
            receiveDept: {editable: true},
            receiMailAddr: {editable: true},
            receiveAmpmScn: {editable: false},
            receiveContents: {editable: true},
          }
        }
      },
      sendBatchSaveColumns: [
        {
          field: 'No',
          title: 'No.',
          width: '3%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          sortable: false
        },
        {
          field: 'contentsScn',
          title: '내용',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'contentsDesc',
          title: '물품 내용 설명',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendFacility',
          title: '발신 사업장 / 거점 / 코스',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendBuilding',
          title: '발신 건물',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendFloor',
          title: '발신 층',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendZone',
          title: '발신 구역',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendNm',
          title: '발신',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendDept',
          title: '발신 부서',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendMailAddr',
          title: '발신 이메일',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendAmpmScn',
          title: '발신 시간',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendContents',
          title: '발신 비고',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveFacility',
          title: '수신 사업장 / 거점 / 코스',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveBuilding',
          title: '수신 건물',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveFloor',
          title: '수신 층',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveZone',
          title: '수신 구역',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveNm',
          title: '수신',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveDept',
          title: '수신 부서',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiMailAddr',
          title: '수신 이메일',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveAmpmScn',
          title: '수신 시간',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveContents',
          title: '수신 비고',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          command: [
            {
              name:'destroy',
              className: "small_btn mr10",
              template: kendo.template(`<a class="small_btn k-grid-destroy mr10" style="height:24px;"><span class="k-icon k-i-trash"></span></a>`),
              click: function (e){
                e.preventDefault()
                let tr = $(e.target).closest('tr')
                let removeItem = this.dataItem(tr)

                vm.$refs.sendBatchGrid.kendoWidget().dataSource.remove(removeItem);
              },
            }
          ],
          width: '8%',
        }
      ],

      sendInfo: {
        sendScnNm: sendScnNm,
        sendScn: sendScn,
        shpcScnNm: shpcScnNm,
        shpcScn: shpcScn,
      }
    }
  }
}
</script>

<style scoped>

</style>